module.exports = __webpack_public_path__ + "img/106.e31817e1.jpg";